import 'dayjs/locale/pt-br'

let date = require('dayjs');
date.locale('pt-br')

export default date;